import React from 'react';
import { Share2, ArrowDown } from 'lucide-react';
import { Reveal } from './Reveal';
export function SectionOne() {
  return <section className="relative flex min-h-screen flex-col justify-end supports-[height:100svh]:min-h-[100svh]" data-id="element-1594">
      <div className="relative flex flex-col gap-10 px-5 pb-16 sm:flex-row sm:items-end sm:justify-between sm:gap-8 sm:px-8 md:px-12 md:pb-20" data-id="element-1595">
        <h1 className="max-w-xl text-4xl font-medium uppercase leading-[1.05] tracking-tight text-white drop-shadow-lg sm:text-5xl md:text-6xl lg:text-7xl" data-id="element-1596">
          <Reveal as="span" delay={100} className="block pl-6 sm:pl-12" data-id="element-1597">
            Today AI
          </Reveal>
          <Reveal as="span" delay={220} className="block" data-id="element-1598">
            Aligns <span className="normal-case italic font-light" data-id="element-1599">with</span>
          </Reveal>
          <Reveal as="span" delay={340} className="block pl-10 sm:pl-20" data-id="element-1600">
            // Bold
          </Reveal>
          <Reveal as="span" delay={460} className="block pl-16 sm:pl-32" data-id="element-1601">
            Dreams
          </Reveal>
        </h1>

        <div className="flex w-full max-w-xs flex-col items-start" data-id="element-1602">
          <Reveal delay={400} className="w-full" data-id="element-1603">
            <div className="mb-6 flex w-full items-center justify-between font-mono text-white sm:mb-8" data-id="element-1604">
              <span className="text-lg" data-id="element-1605">( A )</span>
              <span className="text-xs text-white/70" data-id="element-1606">[ 001 /004 ]</span>
            </div>
          </Reveal>

          <Reveal delay={520} className="w-full" data-id="element-1607">
            <p className="mb-6 text-sm leading-relaxed text-white/85 drop-shadow-md sm:mb-8" data-id="element-1608">
              NovaAI is where your bravest work finds its true expression. We
              hand you the means not only to form the future.
            </p>
          </Reveal>

          <Reveal delay={640} className="w-full" data-id="element-1609">
            <a href="#" className="block w-full rounded-full border border-white/60 px-8 py-3 text-center font-mono text-xs uppercase tracking-[0.15em] text-white transition-all duration-300 hover:bg-white hover:text-black" data-id="element-1610">
              Begin Today
            </a>
          </Reveal>
        </div>
      </div>

      <Reveal delay={760} className="absolute bottom-5 left-5 sm:bottom-6 sm:left-8 md:left-12" data-id="element-1611">
        <button className="text-white/80 hover:text-white transition-colors" aria-label="Share" data-id="element-1612">
          <Share2 size={18} data-id="element-1613" />
        </button>
      </Reveal>

      <Reveal delay={760} className="absolute bottom-5 left-1/2 -translate-x-1/2 sm:bottom-6" data-id="element-1614">
        <ArrowDown size={18} className="animate-bounce text-white/80" data-id="element-1615" />
      </Reveal>
    </section>;
}